export default {
  root: {
    overflow: 'hidden',
    borderRadius: '9px',
    borderCollapse: 'inherit'
  }
}
